export default __webpack_public_path__ + "resources/icons/n420-2e86.png";